var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.814.185a.637.637 0 01.14.688L12.544 19.4a.956.956 0 01-1.693.158l-4.047-6.362-6.36-4.047A.955.955 0 01.6 7.455L19.126.046a.637.637 0 01.688.14V.185zM8.075 12.825l3.516 5.524 6.027-15.07-9.543 9.545zm8.643-10.446L1.651 8.407l5.525 3.515 9.542-9.543z"
  })));
}
export default SvgSendIcon;